import "./Button.css";

// Shared primary button carrying the purchase-page affordances: amber fill,
// lift + darken on hover, and a clear disabled state. Sizes to its content (so
// labels never clip) and forwards all native button props (onClick, type,
// form, disabled, style, ...). Compose extra styling via `className`.
export default function Button({ children, className = "", ...rest }) {
  return (
    <button className={`appButton ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}
